import React from 'react';
import {
  Button,
  getClassNameFactory,
  Sizes,
  TextBoldness,
  Typography,
} from '@dcl/ui';
import { ButtonColor, ButtonKind } from '@dcl/ui/dist/elements/Button';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { SubmitIcon } from '../../icons/SubmitIcon';
import {
  CASE_SUCCESS,
  HELP_BTN,
  SUPPORT_BTN,
  TICKET_OPEN,
} from '../../constants';

export const SubmitModal: React.FC = () => {
  const getClassName = getClassNameFactory(SubmitModal.displayName);

  return (
    <div className={getClassName()}>
      <div className={getClassName({ descendantName: 'submitHeader' })}>
        <div>
          <SubmitIcon />
        </div>
        <Typography
          type={Sizes.MEDIUM}
          tag={TypographyTags.P}
          boldness={TextBoldness.Medium}
        >
          {TICKET_OPEN}
        </Typography>
      </div>
      <div className={getClassName({ descendantName: 'submitDescp' })}>
        <Typography
          type={Sizes.XXTRASMALL}
          tag={TypographyTags.P}
          boldness={TextBoldness.Regular}
        >
          {CASE_SUCCESS}
        </Typography>
      </div>
      <div>
        <Button
          kind={ButtonKind.BUTTON}
          color={ButtonColor.PRIMARY}
          disabled={false}
          onClick={() => {}}
        >
          {HELP_BTN}
        </Button>
      </div>
      <div className={getClassName({ descendantName: 'supportBtn' })}>
        <Button
          kind={ButtonKind.BUTTON}
          color={ButtonColor.SECONDARY}
          disabled={false}
          onClick={() => {}}
        >
          {SUPPORT_BTN}
        </Button>
      </div>
    </div>
  );
};

SubmitModal.displayName = 'SubmitModal';
